export default class HorizontalScroll {
  private container: HTMLElement | null = null;

  private isDragging = false;

  private startX = 0;

  private scrollLeft = 0;

  private scrollMultiplier = 1;

  constructor(selector: string, scrollMultiplier = 1) {
    this.container = document.querySelector(selector);
    this.scrollMultiplier = scrollMultiplier;
    this.init();
  }

  init = () => {
    if (!this.container) return;

    // Добавляем обработчики событий для горизонтальной прокрутки
    this.container.addEventListener('mousedown', this.startDragging);
    this.container.addEventListener('mousemove', this.drag);
    this.container.addEventListener('mouseup', this.stopDragging);
    this.container.addEventListener('mouseleave', this.stopDragging);
  };

  // Методы для горизонтальной прокрутки
  private startDragging = (e: MouseEvent) => {
    e.preventDefault();
    if (!this.container) return;

    this.isDragging = true;
    this.startX = e.pageX - this.container.offsetLeft;
    this.scrollLeft = this.container.scrollLeft;
  };

  private drag = (e: MouseEvent) => {
    e.preventDefault();
    if (!this.isDragging || !this.container) return;

    const x = e.pageX - this.container.offsetLeft;
    const walk = (x - this.startX) * this.scrollMultiplier;
    this.container.scrollLeft = this.scrollLeft - walk;
  };

  private stopDragging = () => {
    if (!this.container) return;

    this.isDragging = false;
  };

  // Метод для удаления обработчиков событий
  destroy = () => {
    if (!this.container) return;

    this.container.removeEventListener('mousedown', this.startDragging);
    this.container.removeEventListener('mousemove', this.drag);
    this.container.removeEventListener('mouseup', this.stopDragging);
    this.container.removeEventListener('mouseleave', this.stopDragging);
    this.container.style.cursor = 'default';
  };
}
